document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.vh-community__track').forEach(track => {

    const originals = [...track.children];

    originals.forEach(item => {
      track.appendChild(item.cloneNode(true));
    });

    requestAnimationFrame(() => {

      const width = track.scrollWidth / 2;

      track.style.setProperty(
        '--vh-track-width',
        `${width}px`
      );

    });

  });

});